export const SAME_SCORE_OFFSET = 0.15;

// Group points by (date, score). When multiple points share same date+score, add a small y-offset so they stack vertically.
export function applySameScoreVerticalOffset(
  pointsArrays: { x: Date; y: number; score?: number }[][]
): void {
  const key = (p: { x: Date; y: number; score?: number }) =>
    `${p.x.getTime()}-${p.score ?? p.y}`;
  const groups = new Map<
    string,
    { point: { x: Date; y: number; score?: number } }[]
  >();
  pointsArrays.forEach((points) => {
    points.forEach((p) => {
      const k = key(p);
      if (!groups.has(k)) groups.set(k, []);
      groups.get(k)!.push({ point: p });
    });
  });
  groups.forEach((arr) => {
    if (arr.length <= 1) return;
    const n = arr.length;
    arr.forEach(({ point }, i) => {
      point.y = point.y + (i - (n - 1) / 2) * SAME_SCORE_OFFSET;
    });
  });
}
